import { Column, Icon, Point, Row, Typography } from '@viewup/ui';
import type { ReactNode } from 'react';

interface ViewingMenuProps {
  icon: ReactNode;
  platform: ReactNode[];
  point: string;
  subTitle: string;
  title: ReactNode;
}

export const ViewingMenu = (props: ViewingMenuProps) => {
  const { title, subTitle, point, platform } = props;

  return (
    <Row
      alignItems='center'
      bgColor='bg.primary'
      br={16}
      css={{
        cursor: 'pointer',
      }}
      justifyContent='space-between'
      p={16}
      shadow='center.normal'
    >
      <Row alignItems='center' gap={16}>
        <Column gap={8}>
          <Typography as='h2' color='text.primary' fontType='body.medium'>
            {title}
          </Typography>
          <Typography
            as='h3'
            color='text.tertiary'
            css={{ whiteSpace: 'pre' }}
            fontType='body2.regular'
          >
            {subTitle}
          </Typography>
          <Row gap={2} mb={24}>
            {platform?.map((icon) => icon)}
          </Row>

          <Row alignItems='center' gap={4}>
            <Icon color='text.point' size='XS' source={Point} />
            <Typography color='text.primary' fontType='body2.medium'>
              {point}
            </Typography>
          </Row>
        </Column>
      </Row>
    </Row>
  );
};
